
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkboxes extends Component {

  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    items: PropTypes.array,
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    label: null,
    value: [],
    className: 'normal-input',
    disabled: false,
  };

  onChange(e, key, isChecked) {

    let value = this.props.value;

    let index;

    if (isChecked) {
      if (value.indexOf(key) > -1) {
        //console.log(key, ' is checked in array');
      } else {
        //console.log(key, ' is checked and not array');
        value.push(key);
      }
    } else {
      if (value.indexOf(key) > -1) {
        //console.log(key, ' is not checked in array splice');
        index = value.indexOf(key);
        value.splice(index, 1);
      } else {
        //console.log(key, ' is not checked and not array');
      }
    }

    this.props.onChange(e, value);
  }

  render() {

    const { value, label, disabled } = this.props;

    let className = 'field-type-checkbox ' + this.props.className;

    let checkboxes = this.props.items.map((item, i) => (
      <div className="field-type-checkboxes" key={i}>
        <input
          type="checkbox"
          id={ item.key }
          name={ item.key }
          onChange={(e) => this.onChange(e, item.key, e.target.checked)}
          checked={ value.indexOf(item.key ) > -1 }
          disabled={disabled}/>
        <label htmlFor={ item.key }>{ item.name }</label>
      </div>
      ));

    return (
      <div className={ className } name={this.props.name}>
        <label>{ label }</label>
        { checkboxes }
      </div>
    );
  }
}

export default Checkboxes;
